// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".edit-button[data-v-802fcd2c]{color:inherit;cursor:pointer}", "",{"version":3,"sources":["webpack://./resources/js/views/contacts/component/career/career-items-list.vue"],"names":[],"mappings":"AAAA,8BAAa,aAAa,CAAC,cAAc","sourcesContent":[".edit-button{color:inherit;cursor:pointer}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
